import React, { useState } from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import Image from 'app/Components/Shared/Image/image';
import SaleLoader from 'app/Components/Shared/SaleLoader/SaleLoader';
import { LogoHelper, LogoType } from 'app/utilities/LogoHelper/helper';


const PhoneInsert = (props) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [errorInForm, setErrorForm] = useState(null);

    const mainLogo = LogoHelper.getLogo(LogoType.MainLogo);

    const validatePhone = () => {
        const phonePattern = /^0((5\d{1})|([2-4,8-9]\d{0,1}))-?\d{7}$/;

        if (!phonePattern.test(phoneNumber) || phoneNumber.length < 9) {
            setErrorForm('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
        } else {
            props.onclick(phoneNumber);
        }
    };

    const renderIcon = () => {
        console.log('template icon: ', props.templateIcon);
        if (props.templateIcon != null && props.templateIcon != '') {
            return <Image src={props.templateIcon} alt='icon' className='iconTop' />;
        } else {
            return <Image className="iconTop"  src={mainLogo} alt='main logo' />;
        }
    };

    return (
        <div className='screenContainer'>
            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    await validatePhone();
                }}>
                {renderIcon()}

                <h3 className={`heading ${props.specialText != null && props.specialText != '' ? 'withSecondary' : ''}`}>
                    {props.specialTitle && props.specialTitle != '' ? props.specialTitle : 'היי, טוב לראות אותך'}
                </h3>
                {props.specialText != null && props.specialText != '' && <h3 className='secondaryHeading'>{props.specialText}</h3>}

                <TextInput
                    placeholder={'מה מספר הטלפון שלך?'}
                    value={phoneNumber}
                    maxLength={'10'}
                    type='text'
                    inputMode='numeric'
                    error={errorInForm}
                    onChange={(e) => {
                        const numberRegex = /^\d+$/;
                        if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 10) {
                            setPhoneNumber(e.target.value);
                            setErrorForm(null);
                        }
                    }}
                />
                {props.isReset && <div className='more-info'>הקוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש</div>}
                <Footer onclick={() => { }} stage={props.stage} />
            </form>
        </div>
    );
};

export default PhoneInsert;
